import { Injectable } from '@angular/core';
import { Action, State, Store, type StateContext } from '@ngxs/store';
import { FeedbackViewerActions } from '@medsurf/flat-actions';
import { ApiControlService } from '@medsurf/flat-services';
import { AuthControlState } from '../../internal';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface FeedbackViewerStateModel {
}

@State<FeedbackViewerStateModel>({
  name: 'feedbackViewer',
  defaults: {}
})
@Injectable()
export class FeedbackViewerState {
  constructor(protected store: Store,
              protected apiControlService: ApiControlService) {
  }

  //<editor-fold desc="Actions">

  @Action(FeedbackViewerActions.SendFeedback)
  sendFeedback(state: StateContext<FeedbackViewerState>,
               {feedback}: FeedbackViewerActions.SendFeedback) {
    return this.apiControlService.sendMessage(
      new FeedbackViewerActions.SendFeedbackRequest(feedback)
    );
  }

  //</editor-fold>
}
